"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _TabContext = _interopRequireDefault(require("./TabContext"));
var _Tab = _interopRequireDefault(require("./components/Tab"));
exports.Tab = _Tab.default;
var _TabPanel = _interopRequireDefault(require("./components/TabPanel"));
exports.TabPanel = _TabPanel.default;
var _TabPanels = _interopRequireDefault(require("./components/TabPanels"));
exports.TabPanels = _TabPanels.default;
var _TabList = _interopRequireDefault(require("./components/TabList"));
exports.TabList = _TabList.default;
const Tabs = ({
  children,
  spacing,
  dataTest,
  defaultSelected,
  onChange
}) => {
  return /*#__PURE__*/React.createElement(_TabContext.default, {
    defaultSelected: defaultSelected,
    onChange: onChange
  }, /*#__PURE__*/React.createElement(_Stack.default, {
    dataTest: dataTest,
    direction: "column",
    spacing: spacing
  }, children));
};
var _default = exports.default = Tabs;